import React, {FC, useEffect} from 'react';
import {
  Backdrop,
  ModalContainer,
  ModalContent,
  ModalWindowWrapper,
  ModalWrapper,
} from './ModalWindow.styles';

export interface ModalWindowContentPadding {
  desktop: string;
  mobile: string;
}

export interface ModalWindowProps {
  children: React.ReactNode;
  isOpen: boolean;
  top?: string;
  left?: string;
  testID?: string;
  width?: string;
  height?: string;
  scrollLock?: boolean;
  borderRadius?: string;
  background?: string;
  padding?: ModalWindowContentPadding;
  overflowIsVisible?: boolean;
  className?: string;
  noMargins?: boolean;
}

const ModalWindow: FC<ModalWindowProps> = ({
  children,
  isOpen,
  left,
  top,
  testID,
  width,
  height,
  scrollLock = false,
  overflowIsVisible,
  borderRadius,
  background,
  padding,
  className,
  noMargins,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll');
    }
  }, [isOpen]);

  return (
    <ModalWrapper isOpen={isOpen} className={className}>
      <ModalContainer
        isOpen={isOpen}
        top={top}
        left={left}
        data-testid={testID}
        width={width}
        height={height}
        scrollLock={scrollLock}
        borderRadius={borderRadius}
        overflowIsVisible={overflowIsVisible}
        noMargins={noMargins}>
        <ModalWindowWrapper
          isOpen={isOpen}
          onClick={e => e.stopPropagation()}
          top={top}
          left={left}>
          <ModalContent
            isOpen={isOpen}
            borderRadius={borderRadius}
            background={background}
            padding={padding}>
            {children}
          </ModalContent>
        </ModalWindowWrapper>
      </ModalContainer>
      <Backdrop
        isOpen={isOpen}
        onClick={e => {
          e.stopPropagation();
        }}
      />
    </ModalWrapper>
  );
};

export default ModalWindow;
